import React, { useRef, useEffect, useState } from 'react';
import styles from './Quote.module.css';

const QUOTE_SLIDES = [
  {
    eyebrow: 'OUR MISSION & CALLING',
    lines: [
      { text: '“Join us where we lead people to ' },
      { text: 'BECOME', highlight: true },
      { text: ' disciples and ' },
      { text: 'MAKE', highlight: true },
      { text: ' disciples of Jesus Christ.”' }
    ],
    ctaText: 'Meet Our Leadership',
    ctaLink: '/leadership',
    tag: 'Everyone Welcome',
  },
  {
    eyebrow: 'TRANSFORMING LIVES',
    lines: [
      { text: '“A community rooted in faith, walking in ' },
      { text: 'HOPE', highlight: true },
      { text: ', and demonstrating Christ’s ' },
      { text: 'LOVE', highlight: true },
      { text: ' to every generation.”' }
    ],
    ctaText: 'Our Beliefs & Values',
    ctaLink: '/beliefs',
    tag: 'Faith & Fellowship',
  },
  {
    eyebrow: 'HEALING & RESTORATION',
    lines: [
      { text: '“Experience true revival, abundant ' },
      { text: 'GRACE', highlight: true },
      { text: ', and divine ' },
      { text: 'PURPOSE', highlight: true },
      { text: ' in Christ Jesus our Lord.”' }
    ],
    ctaText: 'Worship With Us',
    ctaLink: '/eventscalendar',
    tag: 'Fridays in Ruwi',
  },
];

const ROTATING_IMAGES = [
  '/assets/images/IMG2.webp',
  '/assets/images/IMG3.webp',
  '/assets/images/IMG4.webp',
  '/assets/images/IMG5.webp',
  '/assets/images/IMG6.webp',
  '/assets/images/IMG7.webp',
  '/assets/images/IMG8.webp',
];

export default function Quote() {
  const ref = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      },
      { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  // Synchronized Timer: Quote content and image change together
  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setSlideIndex(prev => (prev + 1) % QUOTE_SLIDES.length);
        setImgIndex(prev => (prev + 1) % ROTATING_IMAGES.length);
        setAnimating(false);
      }, 350);
    }, 5500);

    return () => clearInterval(timer);
  }, []);

  const handleSlideSelect = (idx) => {
    if (idx === slideIndex) return;
    setAnimating(true);
    setTimeout(() => {
      setSlideIndex(idx);
      setImgIndex(prev => (prev + 1) % ROTATING_IMAGES.length);
      setAnimating(false);
    }, 250);
  };

  const current = QUOTE_SLIDES[slideIndex];

  return (
    <section className={styles.section}>
      <div ref={ref} className={styles.inner}>
        <div className={styles.quoteWrapper}>
          {/* Progress Indicator Bars (3 Bars) */}
          <div className={styles.slideIndicators}>
            {QUOTE_SLIDES.map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={`${styles.indicatorBar} ${idx === slideIndex ? styles.activeIndicator : ''}`}
                onClick={() => handleSlideSelect(idx)}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>

          <span className={`${styles.eyebrow} ${animating ? styles.fadeExit : styles.fadeEnter}`}>
            {current.eyebrow}
          </span>
          <div className={styles.quoteGlyph} aria-hidden="true">“</div>

          <blockquote className={`${styles.text} ${animating ? styles.fadeExit : styles.fadeEnter}`}>
            {current.lines.map((chunk, i) =>
              chunk.highlight ? (
                <strong key={i} className={styles.goldHighlight}>{chunk.text}</strong>
              ) : (
                <span key={i}>{chunk.text}</span>
              )
            )}
          </blockquote>

          <div className={`${styles.actionRow} ${animating ? styles.fadeExit : styles.fadeEnter}`}>
            <a href={current.ctaLink} className={styles.storyLink}>
              {current.ctaText} <span className={styles.arrowIcon}>➔</span>
            </a>
          </div>
        </div>

        {/* Synchronized Photo Card (Changes together with content) */}
        <a className={styles.easterCard} href={current.ctaLink} aria-label={current.ctaText}>
          <div className={styles.imgWrapper}>
            <img
              src={ROTATING_IMAGES[imgIndex]}
              alt="Faith Fellowship Church Life & Gatherings"
              className={`${styles.cardImg} ${animating ? styles.imgExit : styles.imgEnter}`}
              loading="lazy"
              decoding="async"
              width="600"
              height="400"
            />
          </div>
        </a>
      </div>
    </section>
  );
}